import { HTMLAttributes } from 'react';
import {
  AlignContentProps,
  alignItems,
  AlignItemsProps,
  alignSelf,
  AlignSelfProps,
  background,
  BackgroundProps,
  borderRadius,
  BorderRadiusProps,
  borders,
  BordersProps,
  color,
  ColorProps,
  display,
  DisplayProps,
  flex,
  FlexBasisProps,
  flexDirection,
  FlexDirectionProps,
  FlexProps,
  flexWrap,
  FlexWrapProps,
  gridGap,
  GridGapProps,
  height,
  HeightProps,
  justifyContent,
  JustifyContentProps,
  justifySelf,
  JustifySelfProps,
  MaxHeightProps,
  maxWidth,
  MaxWidthProps,
  minHeight,
  MinHeightProps,
  minWidth,
  MinWidthProps,
  SizeProps,
  space,
  SpaceProps,
  textAlign,
  top,
  TopProps,
  width,
  WidthProps,
} from 'styled-system';
import { styled } from '~ui-kit/styled-components';

/**
 * TODO: replace styled-system props with custom ones from theme/styled-system
 */
export interface BoxProps
  extends BackgroundProps,
    ColorProps,
    FlexWrapProps,
    FlexBasisProps,
    FlexProps,
    FlexDirectionProps,
    GridGapProps,
    SizeProps,
    MinHeightProps,
    MaxHeightProps,
    HeightProps,
    MinWidthProps,
    MaxWidthProps,
    WidthProps,
    SpaceProps,
    FlexProps,
    TopProps,
    AlignItemsProps,
    AlignContentProps,
    JustifyContentProps,
    AlignSelfProps,
    JustifySelfProps,
    DisplayProps,
    BorderRadiusProps,
    BordersProps,
    HTMLAttributes<HTMLDivElement> {
  color?: string;
}

export const Box = styled.div<BoxProps>`
  display: flex;
  position: relative;

  ${width};
  ${height};
  ${minHeight};
  ${space};
  ${flexDirection};
  ${alignSelf};
  ${justifySelf};
  ${justifyContent};
  ${alignItems};
  ${flex};
  ${color};
  ${flexWrap};
  ${textAlign};
  ${top};
  ${minWidth};
  ${maxWidth};
  ${background};
  ${display};
  ${gridGap};
  ${borderRadius};
  ${borders}
`;
